import React, {useState} from "react"
import * as Yup from "yup"
import {connect} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"


// components
import {ButtonCancel,  ButtonSubmit} from "../../../components/buttons/buttonsActions"

// labels
import {PH_CODE, PH_NAME, PH_ORDER} from "../../../components/i18n/placeHolders"
import {FORM, LB_CODE, LB_NAME, LB_ORDER, LB_STATUS, REQUIRED} from "../../../components/i18n/i18n"

// actions
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions"

// services
import {genericActions} from "../../../redux/actions/generics/GenericActions"
import {airportService} from "../../../jwt/_services/hotel/airportService"
import Switch from "react-bootstrap-switch";




const AirportForm = (props) => {
    const { app } = props.mainProps;
    const { editMode, domainObject } = props.formProps;

    const fbDataBase = {id: app?.fbDataBase?.id}
    const [status, setStatus] = useState(domainObject?.status || true);


    const validationSchema = Yup.object().shape({
        name: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : { ...data, }
        };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (!editMode)
            genericActions.save(airportService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(airportService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }


    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
        </CardTitle>
        <CardBody className={'card-body-modal'}>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_NAME}</Label>
                            <Input
                                type="text"
                                name="name"
                                placeholder={PH_NAME}
                                innerRef={register}
                            />
                            { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label>{LB_ORDER}</Label>
                            <Input
                                type="number"
                                name="showOrder"
                                placeholder={PH_ORDER}
                                innerRef={register}
                            />
                            { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>

                </Row>

                <div className="float-right">
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ closeForm }/>
                </div>
            </Form>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(AirportForm);